/* eslint-disable @typescript-eslint/no-unused-vars */
import * as Types from '../../../../graphql/generated';

import { gql } from '@apollo/client';
import * as Apollo from '@apollo/client';
const defaultOptions = {} as const;
export type IDeleteInternalRegulationObligationProcessMutationVariables = Types.Exact<{
  input: Types.IDeleteInternalRegulationObligationProcessInput;
}>;

export type IDeleteInternalRegulationObligationProcessMutation = {
  __typename?: 'Mutation';
  deleteInternalRegulationObligationProcess: {
    __typename?: 'InternalRegulationObligationProcess';
    id: string;
    processCode?: string | null;
    processName?: string | null;
    processDescription?: string | null;
  };
};

export const DeleteInternalRegulationObligationProcessDocument = gql`
  mutation DeleteInternalRegulationObligationProcess($input: DeleteInternalRegulationObligationProcessInput!) {
    deleteInternalRegulationObligationProcess(input: $input) {
      id
      processCode
      processName
      processDescription
    }
  }
`;
export type IDeleteInternalRegulationObligationProcessMutationFn = Apollo.MutationFunction<
  IDeleteInternalRegulationObligationProcessMutation,
  IDeleteInternalRegulationObligationProcessMutationVariables
>;

/**
 * __useDeleteInternalRegulationObligationProcessMutation__
 *
 * To run a mutation, you first call `useDeleteInternalRegulationObligationProcessMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useDeleteInternalRegulationObligationProcessMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [deleteInternalRegulationObligationProcessMutation, { data, loading, error }] = useDeleteInternalRegulationObligationProcessMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useDeleteInternalRegulationObligationProcessMutation(
  baseOptions?: Apollo.MutationHookOptions<
    IDeleteInternalRegulationObligationProcessMutation,
    IDeleteInternalRegulationObligationProcessMutationVariables
  >,
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useMutation<
    IDeleteInternalRegulationObligationProcessMutation,
    IDeleteInternalRegulationObligationProcessMutationVariables
  >(DeleteInternalRegulationObligationProcessDocument, options);
}
export type DeleteInternalRegulationObligationProcessMutationHookResult = ReturnType<
  typeof useDeleteInternalRegulationObligationProcessMutation
>;
export type DeleteInternalRegulationObligationProcessMutationResult =
  Apollo.MutationResult<IDeleteInternalRegulationObligationProcessMutation>;
export type DeleteInternalRegulationObligationProcessMutationOptions = Apollo.BaseMutationOptions<
  IDeleteInternalRegulationObligationProcessMutation,
  IDeleteInternalRegulationObligationProcessMutationVariables
>;
